"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkbox = _interopRequireDefault(require("@paprika/checkbox"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _PropsProvider = require("../../store/PropsProvider");

var _DOMAttributes = require("../../helpers/DOMAttributes");

var sc = _interopRequireWildcard(require("./Option.styles"));

var _excluded = ["index", "groupId", "label", "id", "internalHandleOnClick", "isSelected", "hasNoIcon", "isMulti", "hasTag"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Option = function Option(props) {
  var index = props.index,
      groupId = props.groupId,
      label = props.label,
      id = props.id,
      internalHandleOnClick = props.internalHandleOnClick,
      isSelected = props.isSelected,
      hasNoIcon = props.hasNoIcon,
      isMulti = props.isMulti,
      hasTag = props.hasTag,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var providedProps = _react["default"].useContext(_PropsProvider.PropsContext);

  var isReadOnly = providedProps.isReadOnly,
      size = providedProps.size;
  var isDisabled = providedProps.isDisabled || props.isDisabled || isReadOnly;
  var _Checkbox$types$state = _checkbox["default"].types.state,
      CHECKED = _Checkbox$types$state.CHECKED,
      UNCHECKED = _Checkbox$types$state.UNCHECKED;

  var _React$useState = _react["default"].useState(UNCHECKED),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      checkedState = _React$useState2[0],
      setCheckedState = _React$useState2[1];

  var handleChange = function handleChange() {
    return setCheckedState(checkedState === CHECKED ? UNCHECKED : CHECKED);
  };

  var checkIcon = isMulti && (!hasTag ? /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    checkedState: isSelected ? CHECKED : checkedState,
    onChange: handleChange,
    style: {
      paddingRight: _tokens["default"].space
    }
  }) : /*#__PURE__*/_react["default"].createElement(sc.PlusIcon, null));
  return /*#__PURE__*/_react["default"].createElement(sc.Option, (0, _extends2["default"])({}, moreProps, (0, _DOMAttributes.getA11yAttributesForOption)(isSelected), {
    hasPreventDefaultOnSelect: props.preventDefaultOnSelect,
    id: id,
    isDisabled: isDisabled,
    isSelected: isSelected,
    size: size,
    key: index,
    onClick: function onClick(event) {
      return internalHandleOnClick({
        event: event,
        isDisabled: isDisabled,
        onClick: props.onClick,
        index: index
      });
    },
    "data-pka-anchor": isSelected ? "list-option--is-selected" : "list-option",
    "data-pka-prevent-default-on-select": props.preventDefaultOnSelect,
    tabIndex: -1
  }), hasNoIcon ? null : checkIcon, typeof props.children === "function" ? props.children({
    isSelected: isSelected,
    isDisabled: isDisabled,
    id: id
  }) : props.children);
};

Option.displayName = "ListBox.Option";
Option.propTypes = {
  /** String, number or JSX content */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,

  /* Controls if the option is selected or not, never combine it with defaultIsSelected */
  isSelected: _propTypes["default"].bool,

  /** Describe if the option started as selected or not */
  defaultIsSelected: _propTypes["default"].bool,

  /** When no PlusIcon or CheckBox are needed */
  hasNoIcon: _propTypes["default"].bool,

  /** Describe if the option is enable or not */
  isDisabled: _propTypes["default"].bool,

  /** Describe if the option is hidden or not */
  isHidden: _propTypes["default"].bool,

  /** When the children are not a String, label should need to be add so the filter can work  */
  label: _propTypes["default"].string,

  /** Callback for the clicking event */
  onClick: _propTypes["default"].func,

  /** Value of your option this can be any data structure  */
  value: _propTypes["default"].any,
  // eslint-disable-line

  /** Internal prop, which shouldn't be documented */
  internalHandleOnClick: _propTypes["default"].func,

  /** Internal prop, which shouldn't be documented */
  id: _propTypes["default"].string,

  /** Internal prop, which shouldn't be documented */
  preventDefaultOnSelect: _propTypes["default"].bool
};
Option.defaultProps = {
  hasNoIcon: false,
  isDisabled: false,
  isHidden: false,
  id: "",
  internalHandleOnClick: function internalHandleOnClick() {
    return null;
  },
  preventDefaultOnSelect: false,
  isSelected: null,
  defaultIsSelected: null,
  label: null,
  onClick: null,
  value: null
};

var OptionMemoized = /*#__PURE__*/_react["default"].memo(Option);

var _default = OptionMemoized;
exports["default"] = _default;
//# sourceMappingURL=Option.js.map